export class AiRequestFeedbackModel {
    RequestfeedbackId: number;
    RequestlogId?: number;
    IsLike?: boolean;
    Comments: string;
    OrgId?: number;
    IsActive?: boolean;
    CreatedBy?: number;
    CreatedOn?: Date;
    LastModifiedBy?: number;
    LastModifiedOn?: Date;
}